// Studyo Today Backend
// Package studyo.today.type
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/type/time_interval.proto (package studyo.today.type, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_type_timeofday } from "@buf/googleapis_googleapis.bufbuild_es/google/type/timeofday_pb.js";

/**
 * Describes the file studyo/today/type/time_interval.proto.
 */
export const file_studyo_today_type_time_interval = /*@__PURE__*/
  fileDesc("CiVzdHVkeW8vdG9kYXkvdHlwZS90aW1lX2ludGVydmFsLnByb3RvEhFzdHVkeW8udG9kYXkudHlwZSJkCgxUaW1lSW50ZXJ2YWwSKgoKc3RhcnRfdGltZRgBIAEoCzIWLmdvb2dsZS50eXBlLlRpbWVPZkRheRIoCghlbmRfdGltZRgCIAEoCzIWLmdvb2dsZS50eXBlLlRpbWVPZkRheUIZqgIWU3R1ZHlvLlRvZGF5LkdycGMuVHlwZWIGcHJvdG8z", [file_google_type_timeofday]);

/**
 * Describes the message studyo.today.type.TimeInterval.
 * Use `create(TimeIntervalSchema)` to create a new message.
 */
export const TimeIntervalSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_type_time_interval, 0);

